var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9688 6C13.9688 6.4375 13.625 6.78125 13.2188 6.78125H2.59375L6.75 10.7188C7.0625 11 7.0625 11.5 6.78125 11.7813C6.5 12.0938 6.03125 12.0938 5.71875 11.8125L0.21875 6.5625C0.0625 6.40625 0 6.21875 0 6C0 5.8125 0.0625 5.625 0.21875 5.46875L5.71875 0.218752C6.03125 -0.0624983 6.5 -0.0624983 6.78125 0.250002C7.0625 0.531252 7.0625 1.03125 6.75 1.3125L2.59375 5.25H13.2188C13.6562 5.25 13.9688 5.59375 13.9688 6Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBack);
export default __webpack_public_path__ + "static/media/icon_arrowBack.5e3c884644c724bfbfbe87216187556d.svg";
export { ForwardRef as ReactComponent };